import { motion } from "framer-motion";
import { X, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function BetterWay() {
  const { config } = useSiteConfig();
  const t = config.t.betterWay;
  const COMPARISON = config.lists.comparison;
  return (
    <section className="bg-white py-28 sm:py-36" data-testid="better-way-section">
      <div className="mx-auto max-w-5xl px-6">
        <Reveal className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mx-auto mt-4 text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl lg:text-6xl">{t.heading}</h2>
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          <Reveal className="rounded-3xl border border-black/5 bg-[#FAFAFC] p-8">
            <p className="mb-6 text-sm font-bold uppercase tracking-wide text-neutral-400">The old way</p>
            <ul className="space-y-4">
              {COMPARISON.old.map((o, i) => (
                <motion.li key={o} initial={{ opacity: 0, x: -12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                  className="flex items-center gap-3 text-[15px] text-neutral-500">
                  <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-sos/10 text-sos"><X className="h-3.5 w-3.5" strokeWidth={3} /></span>
                  <span className="line-through decoration-neutral-300">{o}</span>
                </motion.li>
              ))}
            </ul>
          </Reveal>

          <Reveal delay={0.1} className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-brand to-brand-dark p-8 text-white">
            <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-ai/20 blur-2xl" />
            <p className="mb-6 text-sm font-bold uppercase tracking-wide text-white/70">SOSConnect AI</p>
            <ul className="space-y-4">
              {COMPARISON.new.map((n, i) => (
                <motion.li key={n} initial={{ opacity: 0, x: 12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                  className="flex items-center gap-3 text-[15px] font-medium">
                  <span className="grid h-6 w-6 shrink-0 place-items-center rounded-full bg-ai text-black"><Check className="h-3.5 w-3.5" strokeWidth={3} /></span>
                  {n}
                </motion.li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
